module.exports = __webpack_public_path__ + "media/images/certificate/bcs-logo-9a41b19d043cfddb48c68ea23db40e9c.svg";